module.exports = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY_WILLOW,
  tenant: 'willow',
  messageLimit: null,
  messageFlagEnabled: true,
  pageTitle: 'Ema - Willow',
};
